import * as Sentry from '@sentry/browser';
import api, { Response } from 'core/api';

export type FormResultParams = {
  pageNumber: number;
  searchTerm: string;
  sortOrder: string;
  pageSize: number;
  sortBy: string;
  filters: object;
};

export async function getFormResults<T>(
  orgId: number,
  formId: number,
  params: FormResultParams
): Promise<Response<T>> {
  try {
    return await api.post<T>(
      `/organizations/${orgId}/form_result_reports/${formId}`,
      params
    );
  } catch (e) {
    Sentry.captureException(e);
    throw new Error(`Error in getFormResults: ${e}`);
  }
}

export async function getColumns<T>(
  orgId: number,
  formId: number
): Promise<Response<T>> {
  try {
    return await api.get<T>(
      `/organizations/${orgId}/form_result_report_columns/${formId}`
    );
  } catch (e) {
    Sentry.captureException(e);
    throw new Error(`Error in getColumns: ${e}`);
  }
}

export async function getFilters<T>(
  orgId: number,
  formId: number
): Promise<Response<T>> {
  try {
    return await api.get<T>(
      `/organizations/${orgId}/form_result_report_filters/${formId}`
    );
  } catch (e) {
    Sentry.captureException(e);
    throw new Error(`Error in getFilters: ${e}`);
  }
}

export async function getUniqueRegistrationsCount<T>(
  orgId: number,
  formId: number,
  searchTerm: string,
  filters: object
): Promise<Response<T>> {
  try {
    return await api.post<T>(
      `/organizations/${orgId}/retrieve_unique_registrants_count/${formId}`,
      { searchTerm, filters }
    );
  } catch (e) {
    Sentry.captureException(e);
    throw new Error(`Error in getUniqueRegistrationsCount: ${e}`);
  }
}
